<template>
  <div :class="{'loading':!isLoaded}" v-if="options.initialPage">

    <div class="row" v-if="isTwoSearch">
      <div class="col-md-6">
        <search v-model="search"
                v-if="options.withSearch"
                :placeholder="options.texts.filterPlaceholder"
                v-on:enter="onSearchEnter"/>
      </div>
      <div class="col-md-6">
        <search v-model="searchSkillField"
                name="searchSkillField"
                v-if="options.withSearch"
                :placeholder="'protocol.skillField_and_code' | trans"
                v-on:enter="onSearchSkillField"/>
      </div>

    </div>

    <div v-if="!isTwoSearch">
      <search placeholder="Search"
              v-model="search"
              v-if="options.withSearch"
              :placeholder="options.texts.filterPlaceholder"
              v-on:enter="onSearchEnter"/>
    </div>



    <v-server-table
        ref="protocolTable"
        v-if="isList"
        :columns=[tableColumns[indexColumn]]
        :options="options"
        skin="table table-sm">

      <template :slot=tableColumns[indexColumn] slot-scope="props">

        <div class="row">
          <div class="col-md-12">
            <div
                class="title d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <slot name="id" :row="props.row"></slot>
                <slot name="logo" :row="props.row"></slot>
                <strong v-if="props.row.title">{{props.row.title}}</strong>
              </div>
              <div>
                <slot name="action" :row="props.row"></slot>
              </div>
            </div>
          </div>
        </div>

        <div class="description" :class="{'pt-2' : (index == 0)}"
             v-for="(column, key, index) in options.listRow" v-if="!listWithHeaderView && !listHide">
          <p class="gray-dark" v-if="props.row[key]">
            <b v-if="column.headings">{{column.headings}}:</b>
              <span v-if="!props.row[key].date">{{ column.hasTemplate ? options.templates[key](null, props.row) :  props.row[key] }}</span>
              <span v-else>{{ props.row[key].date | toLocaleDate}}</span>
          </p>
          <div v-else>
            <b v-if="column.headings && props.row[key]">{{column.headings}}:</b>
            <slot :name="key" :row="props.row"></slot>
          </div>
        </div>

        <div class="description"
             v-for="(column, key) in options.listRow"  v-if="listWithHeaderView && !listHide">
          <div v-if="props.row[key]">
            <p class="gray-dark head">{{column.headings}}</p>
            <p><span v-if="!props.row[key].date">{{ column.hasTemplate ? options.templates[key](null, props.row) :  props.row[key] }}</span><span
                v-else>{{ props.row[key].date | toLocaleDate}}</span></p>

          </div>
          <div v-else>
            <p class="gray-dark head">{{column.headings}}</p>
            <slot :name="key" :row="props.row"></slot>
          </div>
        </div>


        <slot name="descriptionList" :row="props.row"></slot>
      </template>

    </v-server-table>

    <v-server-table
        :columns=tableColumns
        :options="options"
        ref="protocolTable"
        skin="table table-sm"
        v-if="!isList && withChild">

      <div slot="child_row" slot-scope="props" >
        <slot name="childRow" :row="props.row"></slot>
      </div>


      <template v-for="column in slotColumns" :slot="column" slot-scope="props">
        <div :key="column">
          <slot :name="column" :row="props.row"></slot>
        </div>
      </template>

    </v-server-table>

    <v-server-table
        :columns=tableColumns
        :options="options"
        ref="protocolTable"
        skin="table table-sm"
        v-if="!isList && !withChild">

      <template v-for="column in slotColumns" :slot="column" slot-scope="props">
        <div :key="column">
          <slot :name="column" :row="props.row"></slot>
        </div>
      </template>

    </v-server-table>

  </div>
</template>

<script>

  import filter from 'lodash/filter';
  import map from 'lodash/map';
  import forIn from 'lodash/forIn';
  import keys from 'lodash/keys';
  import Loader from '../../../modules/loader/components/Loader';
  import Search from '../Search'

  export default {
    name: 'tableView',
    props: {
      options: {
        type: Object,
        default: () => {
          return {};
        },
      },
      withChild: {
        type: Boolean,
        default: false,
      },
      isLoaded: {
        type: Boolean,
        default: true,
      },
      isList: {
        type: Boolean,
        default: false,
      },
      listWithHeaderView: {
        type: Boolean,
        default: false,
      },
      isChange: {
        type: Boolean,
        default: false,
      },
      isTwoSearch: {
        type: Boolean,
        default: false,
      },
      indexColumn: {
        type: [Number,String],
        default: 0,
      },
    },
    components: {Search, Loader},
    data() {
      return {
        slotColumns: {
          type: Array,
          default: () => {
            return [];
          },
        },
        tableColumns: {
          type: Array,
          default: () => {
            return [];
          },
        },
        listHide: false,
        search: '',
        searchSkillField: '',
      };
    },
    created() {
      if (this.isList){
        let columns = [];
        forIn(this.options.listRow, function(value, key) {
          columns.push(key)
        });
        this.tableColumns = keys(this.options.listRow);
        let headings = {};
        forIn(this.options.listRow, function(value, key) {
          headings[key] = value.headings;
        });

        this.options.headings = headings;
        this.listHide = (keys(headings).length == 1)

      } else{
        let columnsChanged = filter(this.options.columns, {changed: true});
        this.slotColumns = map(columnsChanged, 'key');
        let columns = map(this.options.columns, 'key');
        this.tableColumns = columns;
        let headings = {};
        forIn(this.options.columns, function(value, key) {
          headings[value.key] = value.headings;
        });

        this.options.headings = headings;
      }
    },

    mounted() {

      if(localStorage.currentPage){

        if(localStorage.getItem("currentPageHeader") === this.options.pageHeader) {
          this.options.initialPage = localStorage.getItem("currentPage");
        }
      }

      this.options.initialPage = this.options.initialPage ? this.options.initialPage : 1;

    },

    beforeDestroy(){
      localStorage.removeItem('currentPage');
    },

    methods: {
      onSearchEnter: async function (search) {

        if(this.isTwoSearch){
          this.search = search;
          this.$refs.protocolTable.query = {
            search: this.search,
            searchSkillField: this.searchSkillField
          };
        } else{
          this.$refs.protocolTable.query = search;
        }

        this.$refs.protocolTable.refresh();

      },
      onSearchSkillField: async function (search) {
        this.searchSkillField = search;
        this.$refs.protocolTable.query = {
          search: this.search,
          searchSkillField: this.searchSkillField
        };
        this.$refs.protocolTable.refresh();

      },
      onRefreshEnter: async function (search) {
        this.$refs.protocolTable.refresh();

      },
    },

    watch: {
      isList(newValue, oldValue) {

          if (newValue) {
            let columns = [];
            forIn(this.options.listRow, function(value, key) {
              columns.push(key)
            });
            this.tableColumns = keys(this.options.listRow);
            let headings = {};
            forIn(this.options.listRow, function(value, key) {
              headings[key] = value.headings;
            });

            this.options.headings = headings;
            this.listHide = (keys(headings).length == 1)

          } else {
            let columnsChanged = filter(this.options.columns, {changed: true});
            this.slotColumns = map(columnsChanged, 'key');
            let columns = map(this.options.columns, 'key');
            this.tableColumns = columns;
            let headings = {};
            forIn(this.options.columns, function(value, key) {
              headings[value.key] = value.headings;
            });

            this.options.headings = headings;

          }
        },
        isChange(newValue, oldValue){

          if (newValue) {
            this.$refs.protocolTable.refresh();
          }
        },


    }

  };
</script>



// WEBPACK FOOTER //
// src/common/table/components/TableView.vue